import React, { useState } from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { Box } from '@mui/system';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import { FormControl, InputAdornment } from '@mui/material';

const dropDownWrapper = {
  width: '100%',
  height: '40px',
  marginRight: '12px',
  display: 'flex',
  justifyContent: 'center',
  fontFamily: 'Inter',
  fontStyle: 'normal',
  fontWeight: 500,
  paddingRight: '10px',
  color: '#4B4B4B',
  borderRadius: '8px',
  backgroundColor: '#fff',
  flexDirections: 'row',
  boxShadow: '0px 2px 10px rgba(0,0,0,0.08)',
  marginTop: '8px',

  '& .MuiInput-root': {
    height: '100%',
    width: '100%',
  },
  '& .MuiSelect-root': {
    height: '100%',
  },
  '& .MuiInputBase-input': {
    padding: 0,
    display: 'flex',
    alignItems: 'center',
  },
  '.css-1d3z3hw-MuiOutlinedInput-notchedOutline': {
    borderColor: 'white!important',
  },
  '.css-ll2gwc': {
    position: 'inherit!important',
  },
  '.css-4cdomc-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root': {
    paddingLeft: '8px',
    width: '100%',
  },
  '.css-1ahhgfv': {
    paddingLeft: '8px',
  },
  '.css-1fvp8d0-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root':{
    width:"100%!important"
  }
};
const listTag = {
  flex: 1,
  height: 40,
};
const labelWrapper = {
  display: 'flex',
  alignItems: 'center',
  maxHeight: '40px',
  flexDirection: 'row',
  fontWeight: 600,
  minWidth: '64px',
};
const defaultStateLabelWrapper = {
  display: 'flex',
  alignItems: 'center',
  maxHeight: '40px',
  flexDirection: 'row',
  fontWeight: 400,
  minWidth: '64px',
  color: '#667085',
};
const label = {
  height: '24px',
  padding: '0px',
  paddingLeft: '5px',
  display: 'flex',
  alignItems: 'center',
  margin: 0,
};

const img = {
  width: '12px',
  height: '12px',
};
const filterTypes = {
  lineHeight: '0px',
  paddingLeft: '8px',
  minWidth: 'max-content',
  fontSize: '14px',
  fontWeight: 600,
  color: '#737373',
};
const FilterDropDown = ({
  changeHandler,
  rootContainerStyle,
  filterType,
  ...props
}) => {
  const [value, setValue] = useState(props.value);
  const onChange = val => {
    setValue(val);
    changeHandler(val);
  };

  return (
    <FormControl sx={dropDownWrapper}>
      {props.inputLabel && (
        <InputLabel id="inputLabel">{props.inputLabel}</InputLabel>
      )}

      <Box style={{ display: 'flex', alignItems: 'center',width:"100%" }}>
        <Select
          MenuProps={{
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'center',
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'center',
            },
            MenuListProps: {
              disablePadding: true,
            },
            getContentAnchorEl: null,
          }}
          sx={{ '.MuiOutlinedInput-notchedOutline': { border: "0px" },'.css-125qdbz.Mui-focused .MuiOutlinedInput-notchedOutline':{border:"0px"}, border:"0px!important",borderColor:"transparent!important" }}
          startAdornment={
            <InputAdornment>
              <MedicalServicesIcon sx={{ color: 'black' }} />
            </InputAdornment>
          }
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          defaultValue="Select the modifier"
          disableUnderline
          displayEmpty
          value={value}
          onChange={onChange}
          {...props}>
          <MenuItem value={null} sx={listTag}>
            <Box sx={defaultStateLabelWrapper}>
              <Box sx={label}>Select the modifier</Box>
            </Box>
          </MenuItem>
          {props?.options?.map((option, index) => {
            return (
              <MenuItem key={index} value={option.value} sx={listTag}>
                <Box sx={labelWrapper}>
                  <Box sx={label}>{option.label || option.value}</Box>
                </Box>
              </MenuItem>
            );
          })}
        </Select>
      </Box>
    </FormControl>
  );
};

export default FilterDropDown;
